<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useAuthStore } from './stores/authStore';
import AppHeader from './components/layout/AppHeader.vue';
import ActorFilterPills from './components/layout/ActorFilterPills.vue';
import NowPlayingBar from './components/layout/NowPlayingBar.vue';
import BottomNav from './components/layout/BottomNav.vue';
import AudioEffectsPanel from './components/layout/AudioEffectsPanel.vue';
import PanicStopButton from './components/PanicStopButton.vue';

const authStore = useAuthStore();
const showEffectsPanel = ref(false);

onMounted(async () => {
  // Try to fetch current user on app load (check if session is valid)
  if (authStore.user) {
    try {
      await authStore.fetchCurrentUser();
    } catch {
      // Session expired
    }
  }
});

function openEffectsPanel() {
  showEffectsPanel.value = true;
}

function closeEffectsPanel() {
  showEffectsPanel.value = false;
}
</script>

<template>
  <div class="min-h-screen flex flex-col overflow-hidden">
    <!-- Header -->
    <AppHeader />

    <!-- Filters (Sticky) -->
    <div class="sticky top-0 z-40 bg-background-dark/80 backdrop-blur-md border-b border-console-border/50 px-4 md:px-8 py-3">
      <div class="max-w-7xl mx-auto">
        <ActorFilterPills />
      </div>
    </div>

    <!-- Main Content -->
    <main class="flex-1 overflow-y-auto px-4 md:px-8 py-6 pb-40">
      <router-view />
    </main>

    <!-- Panic Stop Button -->
    <PanicStopButton />

    <!-- Footer / Now Playing Bar -->
    <footer class="fixed bottom-0 w-full bg-background-dark/95 backdrop-blur-xl border-t border-console-border z-50">
      <NowPlayingBar />
      <BottomNav @open-effects="openEffectsPanel" />
    </footer>

    <!-- Effects Panel (Mobile Drawer) -->
    <AudioEffectsPanel :is-open="showEffectsPanel" @close="closeEffectsPanel" />
  </div>
</template>

